module.exports = __webpack_public_path__ + "img/no_collaborator.8d398e21.png";